import { ref, shallowRef } from "vue";
import { latLng } from "leaflet";

import { currentCenter } from ".";
import { removeEmpty } from "@/services/clear";
import { ajaxRequest } from "@/services/ajax";
import { form } from "@client/elements/address";

import type { Coords, PickupPoints } from "@/types";

export const courierData = shallowRef<PickupPoints[]>();

export const coords = ref<Coords>({ lat: 0, lng: 0 });

export const loading = ref<boolean>(false);

export async function getPickupPoints() {
	loading.value = true;

	try {
		const resp = await ajaxRequest<PickupPoints[]>("POST", "get_pickup_points", { address: removeEmpty(form.value) });

		if (!resp) {
			coords.value = { lat: currentCenter.value?.lat || 0, lng: currentCenter.value?.lng || 0 };
			return;
		}

		const addressLat = form.value?.latitude;
		const addressLng = form.value?.longitude;

		let currentLatLng;

		if (addressLat && addressLng) {
			currentLatLng = latLng(+addressLat, +addressLng);
		} else {
			currentLatLng = latLng(currentCenter.value?.lat || 0, currentCenter.value?.lng || 0);
		}

		const sortedResp = resp
			?.filter((curr) => curr && curr.locations && curr.locations.length > 0 && curr.locations[0].geo)
			.map((curr) => {
				const pickupLatLng = latLng(curr.locations[0].geo.latitude, curr.locations[0].geo.longitude);
				const distance = currentLatLng.distanceTo(pickupLatLng);

				return {
					...curr,
					distance: distance
				};
			})
			.sort((a, b) => a.distance - b.distance);

		if (sortedResp.length > 0) {
			coords.value = {
				lat: sortedResp[0].locations[0].geo.latitude,
				lng: sortedResp[0].locations[0].geo.longitude
			};
		} else {
			coords.value = { lat: currentCenter.value?.lat || 0, lng: currentCenter.value?.lng || 0 };
		}

		courierData.value = sortedResp;
	} catch (error) {
		console.error("Error fetching data: ", error);
	} finally {
		loading.value = false;
	}
}
